import { RefObject, useRef } from 'react';

export default function useDeepRef<Type = any>(value: any): RefObject<Type> {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}
